import React, { useContext } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import Clickable from 'components/Common/Clickable'
import config from 'constants/config'
import Image from 'components/Common/Image'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import GeoContext from 'contexts/geoContext'
import { campaignRegionImages } from 'components/utils/tour-luxplus-campaign-regions'

const BannerImage = styled(Image)`
  width: 100%;
`

function TourCatalogueBanner() {
  const intl = useIntl()
  const { currentRegionCode } = useContext(GeoContext)

  if (currentRegionCode in campaignRegionImages && config.TOUR_LUXPLUS_CAMPAIGN_ENABLED) {
    return null
  }

  const altText = intl.formatMessage(
    {
      id: 'HeyLosB0wH',
      defaultMessage: 'Tour the world with us',
      description: 'Alt text for tour catalogue banner image',
    },
  )

  return <Clickable href={config.tourCatalogueLink} target="_blank" rel="noopener noreferrer">
    <CSSBreakpoint min="tablet">
      <BannerImage image={{ id: 'zzzzuqfw5azbfszyet2k' }} alt={altText} />
    </CSSBreakpoint>
    <CSSBreakpoint max="mobile">
      <BannerImage image={{ id: 'nqggu8fe8vqzm7ot7c1m' }} alt={altText} />
    </CSSBreakpoint>
  </Clickable>
}

export default TourCatalogueBanner
